<template>
  <div class="loader" :class="{ 'loader--visible': visible }">
    <b-spinner />
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

export default {
  name: 'Loader',
  components: {
    BSpinner
  },
  props: ['visible']
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables/_variables';
.loader {
  color: $purple;
  transition: 0.15s ease-in opacity;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  opacity: 1;
  &--visible {
    opacity: 0;
    pointer-events: all;
  }
}

.dark-layout .loader {
  color: $dark-layout-purple !important;
}
</style>
